/*!
 * NAO CRO — Carrousel de réassurance PDP (3 messages)
 * Fichier léger, autonome, sans dépendance externe. Chargé en <script defer>
 * une seule fois par instance de section (voir snippets/pdp-header.liquid).
 * Ne touche à aucune logique Infinite Options / Zepto / formulaire / panier.
 */
(function () {
  var SLIDE_INTERVAL_MS = 4000;

  // Registre global des instances actives, pour arrêter proprement les
  // timers des noeuds retirés du DOM (ex: rechargement d'une section dans
  // l'éditeur de thème) sans perturber les instances toujours en place.
  window.__naoReassuranceSliders = window.__naoReassuranceSliders || [];

  function sweepDetachedInstances() {
    window.__naoReassuranceSliders = window.__naoReassuranceSliders.filter(function (entry) {
      if (!entry.root.isConnected) {
        entry.stop();
        return false;
      }
      return true;
    });
  }

  function initSlider(root) {
    if (root.dataset.naoRsInitialized === '1') return;
    root.dataset.naoRsInitialized = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.nao-pdp-reassurance-slider__slide'));
    var indicators = Array.prototype.slice.call(root.querySelectorAll('.nao-pdp-reassurance-slider__indicator'));
    if (!slides.length || !indicators.length) return;

    var reduceMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var current = 0;
    var timer = null;

    function prefersReducedMotion() {
      return !!(reduceMotionQuery && reduceMotionQuery.matches);
    }

    function setActive(index) {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      indicators.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      current = index;
    }

    function goToNext() {
      setActive((current + 1) % slides.length);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (prefersReducedMotion()) return;
      timer = window.setInterval(goToNext, SLIDE_INTERVAL_MS);
    }

    indicators.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        // Le clic met en pause le défilement automatique le temps de
        // l'interaction, puis relance un cycle propre depuis ce message.
        setActive(i);
        startAutoplay();
      });
    });

    if (reduceMotionQuery && reduceMotionQuery.addEventListener) {
      reduceMotionQuery.addEventListener('change', function () {
        startAutoplay();
      });
    }

    setActive(0);
    startAutoplay();

    window.__naoReassuranceSliders.push({ root: root, stop: stopAutoplay });
  }

  function initAll() {
    sweepDetachedInstances();
    var roots = document.querySelectorAll('[data-nao-reassurance-slider]');
    for (var i = 0; i < roots.length; i++) {
      initSlider(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
